import { post } from "helpers/api_helper/ApiHelpers/apiHelpers"
import * as url from "helpers/url_helper/url_helper"

export const getTransactionProvisionList = (record) => post(url.GET_TRANSACTION_PROVISION_LIST,record)
export const getTransactionProvisionSearch = (record) => post(url.GET_TRANSACTION_PROVISION_SEARCH, record);
export const getTransactionProvisionLinkedAmount = (record) => post(url.GET_TRANSACTION_PROVISION_LINKED_AMOUNTS, record);

